import { useState } from "react";
import Sidebar from "./components/Sidebar";
import AddJobTab from "./components/AddJobTab";
import ManageJobsTab from "./components/ManageJobsTab";
import ApplicantsTab from "./components/ApplicantsTab";
import StatsTab from "./components/StatsTab";
import { Menu } from "lucide-react";

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("stats");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const renderTab = () => {
    switch (activeTab) {
      case "add":
        return <AddJobTab />;
      case "manage":
        return <ManageJobsTab />;
      case "applicants":
        return <ApplicantsTab />;
      case "stats":
      default:
        return <StatsTab />;
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100" dir="rtl">
      {/* Sidebar */}
      <Sidebar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />

      {/* Toggle Button للشاشات الصغيرة */}
      <div className="md:hidden fixed top-4 left-4 z-50">
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600 text-white p-2 rounded shadow-md"
        >
          <Menu className="w-6 h-6" />
        </button>
      </div>

      {/* المحتوى الرئيسي */}
      <main className="flex-1 p-6 overflow-y-auto transition-all duration-300">
        {renderTab()}
      </main>
    </div>
  );
};

export default AdminDashboard;
